import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteDebugger: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Route changed
  }, [location]);

  // Este componente no renderiza nada, solo monitorea rutas
  return null;
};

export default RouteDebugger;



